export default defineNuxtRouteMiddleware((to, from) =>
{
    if (to && 'auth' in to.meta)
        return;

    to.meta.auth = true;
});
